export const NOTIF_SUBSCRIBE_FAIL = 'NOTIF_SUBSCRIBE_FAIL';
export const NOTIF_SUBSCRIBE_SUCCESS = 'NOTIF_SUBSCRIBE_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/notifications.js